export const enum PaginationViewStoreEvent {
  clickPage = 'clickPage',
}
